import React from 'react'
import { timeUtils } from '../../services/timerService'

interface TimerDisplayProps {
  elapsedTime: number
  isRunning: boolean
  className?: string
}

const TimerDisplay: React.FC<TimerDisplayProps> = ({ 
  elapsedTime, 
  isRunning, 
  className = '' 
}) => {
  const formattedTime = timeUtils.formatDuration(elapsedTime)

  return (
    <div className={`text-center ${className}`}>
      <div className="relative">
        {/* 背景裝飾 - 手機版簡化 */}
        <div className={`
          absolute inset-0 rounded-lg md:rounded-2xl opacity-20 md:opacity-30
          ${isRunning 
            ? 'bg-gradient-to-br from-green-50 to-emerald-50' 
            : 'bg-gradient-to-br from-gray-50 to-slate-50'
          }
          transition-all duration-500
        `} />
        
        {/* 計時器顯示 */}
        <div className="relative z-10 py-2 md:py-4">
          <div className={`
            text-xl md:text-4xl font-mono font-bold tracking-wider
            ${isRunning 
              ? 'text-green-600' 
              : 'text-secondary-600'
            }
            transition-all duration-300
            font-variant-numeric: tabular-nums;
            filter: ${isRunning ? 'drop-shadow(0 0 8px rgba(34, 197, 94, 0.3))' : 'none'}
          `}
          style={{ fontVariantNumeric: 'tabular-nums' }}>
            {formattedTime}
          </div>
          
          {/* 狀態指示器 */}
          <div className="flex items-center justify-center mt-1 md:mt-4 space-x-2 md:space-x-3">
            <div className="relative">
              <div className={`
                w-1.5 h-1.5 md:w-3 md:h-3 rounded-full transition-all duration-300
                ${isRunning ? 'bg-green-500' : 'bg-gray-400'}
              `} />
              {isRunning && (
                <>
                  {/* 外圍光暈 - 手機版縮小 */}
                  <div className="absolute inset-0 w-1.5 h-1.5 md:w-3 md:h-3 bg-green-400 rounded-full animate-ping opacity-75" />
                  {/* 呼吸燈效果 - 手機版縮小 */}
                  <div className="absolute inset-0 w-1.5 h-1.5 md:w-3 md:h-3 bg-green-500 rounded-full animate-pulse" />
                </>
              )}
            </div>
            <span className={`
              text-xs md:text-sm font-medium tracking-wide
              ${isRunning ? 'text-green-600' : 'text-secondary-500'}
              transition-all duration-300
            `}>
              {isRunning ? '進行中' : '已停止'}
            </span>
          </div>
          
          {/* 進行中時的底部裝飾線 - 手機版簡化 */}
          {isRunning && (
            <div className="mt-1 md:mt-4 flex justify-center">
              <div className="w-8 md:w-16 h-0.5 bg-gradient-to-r from-transparent via-green-400 to-transparent animate-pulse" />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default TimerDisplay
